export const COMMUNITY_GUIDELINES = {
  TITLE: 'Mixus Community Guidelines',
  LINK: '/organization-guidelines',
  SECTIONS: [
    {
      title: 'Content Standards',
      rules: [
        'No explicit sexual content or adult material',
        'No hate speech, discrimination, or harassment',
        'No excessive profanity or offensive language',
        'No harmful, dangerous, or violent content',
        'No personal attacks or bullying',
        'No promotion of illegal activities',
        'No spam or misleading content'
      ]
    },
    {
      title: 'Chat Publishing Requirements',
      rules: [
        'Chats must have meaningful interaction beyond basic greetings',
        'Content must be appropriate for a general audience',
        'Titles must reflect actual discussion content',
        'No generic AI responses or meaningless titles',
        'Minimum substantive content required',
        'Respect intellectual property rights'
      ]
    }
  ]
};
